import { render, staticRenderFns } from "./ModalStatusPerTypeCount.vue?vue&type=template&id=25799814&"
import script from "./ModalStatusPerTypeCount.vue?vue&type=script&lang=js&"
export * from "./ModalStatusPerTypeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports